// @ts-nocheck
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './snackbar.module.scss';
import { removeSnackMessage } from '@greenkub-fronts/domain/snackbar';
import { CSSTransition } from 'react-transition-group';
import {
  AppDispatch,
  RootState,
  SnackBarMessage,
} from '@greenkub-fronts/shared/interface';
import Icon from '../../icon/icon';
import { IconEnum } from '../../icon/icon.enum';

export const Snackbar = () => {
  const nodeRef = useRef(null);
  const dispatch = useDispatch<AppDispatch>();

  const messages = useSelector((state: RootState) => state.snackbar.messages);
  const [msgsTimeouts, setMsgsTimeouts] = useState<number[]>([]);

  useEffect(() => {
    const msgsIds = messages.map((msg: SnackBarMessage) => msg.id);
    const newMsgsTimeouts = msgsTimeouts.filter((msgId) =>
      msgsIds.includes(msgId)
    );

    for (const msg of messages) {
      if (!msgsTimeouts.includes(msg.id)) {
        newMsgsTimeouts.push(msg.id);
        setTimeout(() => {
          dispatch(removeSnackMessage(msg.id));
        }, 10000);
      }
    }

    setMsgsTimeouts(newMsgsTimeouts);
  }, [messages]);

  return (
    <ul className={styles['Snackbar']}>
      {messages.map((msg) => (
        <CSSTransition
          classNames={styles['Snackbar-item']}
          key={msg.id}
          in={true}
          appear={true}
          addEndListener={(node, done) => {
            node.addEventListener('transitionend', done, false);
          }}
          nodeRef={nodeRef}
          timeout={200}
        >
          <li className={styles['Snackbar-item'] + ' ' + styles[msg.severity]}>
            {msg.severity === 'success' && (
              <Icon name={IconEnum.CHECK_CIRCLE_OUTLINE} />
            )}
            {msg.severity === 'error' && (
              <Icon name={IconEnum.ERROR_OUTLINED} />
            )}

            <span>{msg.content}</span>

            <button
              className={styles['Snackbar-itemClear']}
              onClick={() => {
                dispatch(removeSnackMessage(msg.id));
              }}
            >
              <Icon name={IconEnum.CLOSE} />
            </button>
          </li>
        </CSSTransition>
      ))}
    </ul>
  );
};
